import type { Action } from 'redux'

import type { Menu } from '@library/menu-service'

import { actionTypes } from 'actions/actionTypes'

export type MenuRequest = {
  deliveryDate?: string
  numPortions?: number
}

export type MenuMetadataState = {
  menuMetadata: {
    request: MenuRequest | null
    isLoaded: boolean
    id: string | null
    recommendationId: string | null
  }
}

export const menuInitialState: MenuMetadataState['menuMetadata'] = {
  request: null,
  isLoaded: false,
  id: null,
  recommendationId: null,
}

export type MenuMetadataAction = Action<string> & { response: Menu; request: MenuRequest }

export const menuV3Reducers = {
  menuMetadata: (
    state = menuInitialState,
    action: MenuMetadataAction,
  ): MenuMetadataState['menuMetadata'] => {
    switch (action.type) {
      case actionTypes.MENU_SERVICE_V3_DATA_RECEIVED: {
        return {
          ...state,
          request: action.request,
          isLoaded: true,
          id: action.response.id,
          recommendationId: action.response.recommendations.id,
        }
      }

      default:
        return state
    }
  },
}
